import axios from 'axios'

class Api {

  /**
   * @constructor
   */
  constructor() {
    this._price = null
    this._recovered = null
    this._client = axios.create({
      baseURL: 'https://api.ptdefender.com',
      headers: { 'Content-Type': 'application/json' }
    })
  }

  /**
   * @method setLicense
   */
  setLicense(newValue) {
    this._client.defaults.headers['authorization'] = `bearer ${newValue}`
  }

  /**
   * @method checkout
   */
  async checkout(data) {
    return await this._request('post', '/commerce-checkout', { data })
  }

  /**
   * @method register
   */
  async register(data) {
    return await this._request('post', '/auth/register', { data })
  }

  /**
   * @method price
   */
  async price() {
    if (this._price) return this._price
    let { price } = await this._request('get', '/auth/price')
    this._price = price
    return price
  }

  /**
   * @method recovered
   */
  async recovered() {
    if (this._recovered) return this._recovered
    let recovered = await this._request('get', '/metrics/recovered')
    this._recovered = recovered
    return recovered
  }

  /**
   * @method downloadLinks
   */
  async downloadLinks() {
    return await this._request('get', '/auth/download')
  }

  /**
   * @method recover
   */
  async recover(data) {
    return await this._request('post', '/auth/recover', { data })
  }

  /**
   * @method me
   */
  async me() {
    return await this._request('get', '/user/me')
  }

  /**
   * @method monitor
   */
  async monitor() {
    return await this._request('get', '/monitor')
  }

  /**
   * @method deleteJob
   */
  async deleteJob(id) {
    return await this._request('delete', `/job/${id}`)
  }

  /**
   * @method listSubscriptions
   */
  async listSubscriptions() {
    return await this._request('get', '/subscription')
  }

  /**
   * @method readSubscription
   */
  async readSubscription(id) {
    return await this._request('get', `/subscription/${id}`)
  }

  /**
   * @method cancelSubscription
   */
  async cancelSubscription(id) {
    return await this._request('delete', `/subscription/${id}`)
  }

  /**
   * @method updateSubscription
   */
  async updateSubscription(id, data) {
    return await this._request('put', `/subscription/${id}`, { data })
  }

  /**
   * @method listExchanges
   */
  async listExchanges(params) {
    return await this._request('get', `/exchange`, { params })
  }

  /**
   * @method updateExchange
   */
  async updateExchange(id, data) {
    return await this._request('put', `/exchange/${id}`, { data })
  }

  /**
   * @method registerAffiliate
   */
  async registerAffiliate(data) {
    return await this._request('post', '/affiliate', { data })
  }

  /**
   * @method affiliateSales
   */
  async affiliateSales(params) {
    return await this._request('get', '/affiliate-sales', { params })
  }

  /**
   * @private
   * @method _get
   * @param {String} url
   * @param {Object} [params]
   * @return {Promise}
   */
  async _request(method, url, { data, params } = {}) {
    let options = { method, url, data, params }
    let res = await this._client.request(options)
    return res.data
  }
}

export default new Api()
